<script lang="ts" setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';

const props = defineProps<{
  page: number;
  active?: boolean;
  disabled?: boolean;
}>();

const route = useRoute();

const to = computed(() => {
  const query = {
    ...route.query,
    page: props.page.toString(),
  };
  return { name: route.name, query };
});
</script>

<template>
  <RouterLink
    v-if="!disabled"
    :class="['inline-flex items-center border-t-2 px-4 pt-4 text-sm font-medium', { 'border-ph-green-500 text-ph-green-600': active }, { 'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700': !active }]"
    :to="to"
  >
    <slot />
  </RouterLink>
  <span v-else class="inline-flex items-center border-t-2 border-transparent px-4 pt-4 text-sm font-medium text-gray-300">
    <slot />
  </span>
</template>

<style lang="css" scoped></style>
